import React from 'react'
import { Route } from 'react-router'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'

const PartialInvoiceEditView = React.lazy(() => import('@/modules/partialInvoice/partial-invoice-edit-view'))

const partialInvoiceRoutes = (
  <>
    <Route path='partialinvoice/*' element={<RedirectToPlural />} />
    <Route path='partialinvoices/edit/:id' Component={PartialInvoiceEditView} />
  </>
)

export default partialInvoiceRoutes
